<template>
  <div class="d-flex justify-content-center">
    <img
        class="mt-2 mt-md-4 w-100 logo"
        :src="require('../../assets/img/svg/muniman-Logo-white.png')"
        alt=""
    >
  </div>
</template>

<script>
export default {
  name: "CustomerLogo"
};
</script>

<style scoped>
/* Mobile: 50-70% of screen width */
.logo {
  max-width: 70vw;
}

/* Medium screens and up: 25% of screen width */
@media (min-width: 768px) {
  .logo {
    max-width: 25vw;
  }
}
</style>